<template>
    <div class="modal fade" id="addToCampaign" tabindex="-1" role="dialog" aria-labelledby="addEditCampaignGroup" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Add to Campaign</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- <h2 class="text-center">Editing Campaign Group</h2> -->
                    <div class="form-container">
                        <!-- form start-->
                        <form>
                            <div class="form-group">
                                <label>Select Campaign</label>
                                <select class="form-control">
                                    <option>Select Campaign</option>
                                    <option>Campaign 1</option>
                                    <option>Campaign 2</option>
                                    <option>Campaign 3</option>
                                    <option>Campaign 4</option>
                                    <option>Campaign 5</option>
                                </select>
                            </div>
                        </form>
                        <!-- form end-->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'ProductListAddToCampaign',
    props: {
    }
}
</script>

<style lang="scss">

</style>
